var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.609,8.957H26.9A5.458,5.458,0,0,0,29.13,4.991,3.276,3.276,0,0,0,25.652,2C22.243,2,19.461,5.27,18,7.565,16.47,5.27,13.757,2,10.348,2,7.983,2,6.87,3.461,6.87,4.991S7.565,7.7,9.1,8.957h-5.7A1.391,1.391,0,0,0,2,10.348v5.565A1.391,1.391,0,0,0,3.391,17.3H4.783v15.3A1.391,1.391,0,0,0,6.174,34H29.826a1.391,1.391,0,0,0,1.391-1.391V17.3h1.391A1.391,1.391,0,0,0,34,15.913V10.348A1.391,1.391,0,0,0,32.609,8.957ZM25.652,4.783c.139,0,.7,0,.7.209s-1.67,2.922-5.7,3.687C21.9,6.87,23.843,4.783,25.652,4.783Zm-15.3,0c1.878,0,3.757,2.087,5.078,3.9-4.035-.765-5.7-2.783-5.7-3.687S10.139,4.783,10.348,4.783ZM4.783,11.739H16.609v2.783H4.783ZM7.565,17.3h9.043V31.217H7.565Zm20.87,13.913H19.391V17.3h9.043Zm2.783-16.7H19.391V11.739H31.217Z",
    transform: "translate(-2 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.2f597bad478e59da294dbfacab47ab12.svg";
export { ForwardRef as ReactComponent };